import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IdInterface, OrderClientInterface, SelectedProductInterface } from '../data';
import { OrderProvider } from '../providers/order.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetSelectedProductSignatoriesUseCaseParams {
    product: SelectedProductInterface;
    clientCode: IdInterface;
}

@Injectable()
export class GetSelectedProductSignatoriesUseCase
    implements UseCaseWithParam<GetSelectedProductSignatoriesUseCaseParams, Observable<Transaction<OrderClientInterface[]>>>
{
    constructor(private orderProvider: OrderProvider) {}

    bind(params: GetSelectedProductSignatoriesUseCaseParams): Observable<Transaction<OrderClientInterface[]>> {
        return this.orderProvider.findSignatories(params.product, params.clientCode).pipe(
            map((transaction) =>
                transaction.map(
                    (signatories) => Transaction.success(cloneDeep(signatories)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
